import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headerBG": _vm.headerBG,
      "headline": `${_vm.viewModel ? _vm.viewModel.title : _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.monitoringHeadline')}`,
      "subtitle": _vm.viewModel ? `ID: ${_vm.viewModel.id}` : undefined
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.tabItem === 'info' ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formIsValid,
            "title": _vm.$i18n_t('Common.save'),
            "prepend-icon": "fa-save",
            "data-cy": "save_btn"
          },
          on: {
            "click": _vm.saveView
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n      ")]) : _vm._e(), _vm.tabItem === 'alarmreports' ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Core.ListViewPage.createButton.label'),
            "prepend-icon": "fal fa-plus"
          },
          on: {
            "click": _vm.createAlarmReport
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.ListViewPage.createButton.label')) + "\n      ")]) : _vm._e(), _c('core-button', {
          attrs: {
            "data-cy": "loadmap_btn",
            "color": _vm.color,
            "prepend-icon": "fa-map-marked-alt"
          },
          on: {
            "click": _vm.openMapview
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap')) + "\n      ")]), _c('core-button', {
          attrs: {
            "color": "danger",
            "title": _vm.$i18n_t('Common.cancel'),
            "prepend-icon": "fa-times",
            "data-cy": "close_btn"
          },
          on: {
            "click": _vm.closeView
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VTabs, {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#dashboard"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.drawer.twinDashboard')) + "\n          ")]), _c(VTab, {
    attrs: {
      "href": "#info"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n          ")]), _c(VTab, {
    attrs: {
      "href": "#deviceTemplates"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.drawer.virtualDeviceTemplates')) + "\n            "), _vm.relatedTemplatesCount !== undefined ? [_vm._v("(" + _vm._s(_vm.relatedTemplatesCount) + ")")] : _vm._e()], 2), _c(VTab, {
    attrs: {
      "href": "#virtualdevices"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnVirtualDevices')) + "\n            "), _vm.virtualDeviceCount !== undefined ? [_vm._v("(" + _vm._s(_vm.virtualDeviceCount) + ")")] : _vm._e()], 2), _c(VTab, {
    attrs: {
      "href": "#virtualdevicedrivers"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnVirtualDeviceDrivers')) + "\n            "), _vm.ddTotalCount !== undefined ? [_vm._v("(" + _vm._s(_vm.ddTotalCount) + ")")] : _vm._e()], 2), _c(VTab, {
    attrs: {
      "href": "#alarmlogs"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.alarmLogs')) + "\n          ")]), _vm.isVirtualDeviceManager ? _c(VTab, {
    attrs: {
      "href": "#alarmreports"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.alarmReports')) + "\n            "), _vm.alarmReportsCount !== undefined ? [_vm._v("(" + _vm._s(_vm.alarmReportsCount) + ")")] : _vm._e()], 2) : _vm._e(), _c(VTabsItems, {
    staticClass: "mt-4",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "dashboard",
    attrs: {
      "value": "dashboard"
    }
  }, [_c('core-virtual-device-smart-groups-dashboard', {
    attrs: {
      "accounts": _vm.accounts,
      "viewModel": _vm.viewModel,
      "bridgeTypesProp": _vm.bridgeTypes
    },
    on: {
      "virtual-device-count": e => {
        _vm.virtualDeviceCount = e;
      },
      "related-templates-count": e => {
        _vm.relatedTemplatesCount = e;
      }
    }
  })], 1), _c(VTabItem, {
    key: "info",
    attrs: {
      "eager": "",
      "value": "info"
    }
  }, [_c('core-virtual-device-smart-groups-meta-edit', {
    ref: "metaEdit",
    attrs: {
      "smart-group": _vm.viewModel
    },
    on: {
      "save": _vm.handleUpdate,
      "change": _vm.updateViewModel
    }
  })], 1), _c(VTabItem, {
    key: "deviceTemplates",
    attrs: {
      "value": "deviceTemplates"
    }
  }, [_c('core-list-view-page', {
    ref: "listViewPage",
    attrs: {
      "fetch-items": _vm.fetchTemplates,
      "fetchErrorMessage": 'DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchError',
      "external-fetch-params": {
        selectedAccounts: _vm.selectedAccounts
      },
      "table-headers": _vm.tableHeaders,
      "row-href": item => _vm.getSingleTemplateUrl(item.id),
      "show-header": false,
      "empty-state-icon": "fal fa-sensor-on",
      "empty-state-title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.emptyState.title'),
      "empty-state-description": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.emptyState.description')
    }
  })], 1), _c(VTabItem, {
    key: "virtualdevices",
    attrs: {
      "value": "virtualdevices"
    }
  }, [_c(VChipGroup, {
    attrs: {
      "column": ""
    }
  }, [_c(VChip, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.titleAccount')) + ": \n                  "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                    " + _vm._s((_vm.viewModel || {}).account) + "\n                  ")])]), _vm._l(((_vm.viewModel || {}).viewConfig || {}).searchItems, function (tag, idx) {
    return _c(VChip, {
      key: `chip-${idx}`,
      attrs: {
        "small": ""
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.getVariableText(tag)) + ": \n                  "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                    " + _vm._s((tag.search || {}).text === undefined ? tag.search : tag.search.text) + "\n                  ")])]);
  })], 2), _c('core-virtual-device-list', {
    attrs: {
      "accounts": [{
        id: (_vm.viewModel || {}).tenantId
      }],
      "searchTypes": _vm.searchTypes,
      "predefinedSearch": _vm.predefinedSearch,
      "initOperator": _vm.get(_vm.viewModel, 'viewConfig.searchOperator', 'AND'),
      "restoreFilter": false,
      "favouriteFilterEnabled": false,
      "containerClass": "pa-0"
    }
  })], 1), _c(VTabItem, {
    key: "virtualdevicedrivers",
    attrs: {
      "value": "virtualdevicedrivers",
      "eager": ""
    }
  }, [_c('core-virtual-device-driver-list', {
    attrs: {
      "hide-header": "",
      "smart-group-id": _vm.smartGroupId
    },
    on: {
      "update:total-count": _vm.updateDDTotalCount
    }
  })], 1), _c(VTabItem, {
    key: "alarmlogs",
    attrs: {
      "value": "alarmlogs"
    }
  }, [_c('core-alarm-logs-list', {
    attrs: {
      "containerClass": "",
      "staticSearchItems": [{
        variable: 'smartGroupIds',
        search: [_vm.smartGroupId]
      }]
    }
  })], 1), _c(VTabItem, {
    key: "alarmreports",
    attrs: {
      "value": "alarmreports"
    }
  }, [_c('core-alarm-logs-report-list', {
    ref: "alarmreportlist",
    attrs: {
      "show-header": false,
      "smart-group-id": _vm.smartGroupId,
      "account-id": (_vm.viewModel || {}).tenantId
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };